import { useState } from 'react';

export const useToast = () => {
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: 'success',
    message: ''
  });

  // Función para mostrar notificaciones toast
  const mostrarToast = (type, message) => {
    setToastConfig({
      isVisible: true,
      type: type,
      message: message
    });
  };

  return {
    toastConfig,
    mostrarToast
  };
};
